<!-- Appointments Modal -->
<div
  class="modal fade"
  id="appointmentsModal"
  tabindex="-1"
  aria-labelledby="appointmentsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="max-width: fit-content">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Informações do funcionário e data selecionada no topo do modal -->
        <div class="alert alert-info mb-3" role="alert">
          <div class="row">
            <div class="col-md-6"><strong>👤 Funcionário:</strong> {{ person?.name }}</div>
            <div class="col-md-6"><strong>🏢 Empresa:</strong> {{ person?.officeName }}</div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12"><strong>📅 Data Selecionada:</strong> {{ selectedDateForModal$ | async }}</div>
          </div>
        </div>

        <!-- Seletor de Lista: Rotinas / Tarefas / Metas -->
        <mat-toolbar
          color="primary"
          class="mb-3 modal-list-selector-toolbar modal-toolbar-desktop"
          style="border-radius: 8px"
        >
          <span class="d-flex align-items-center" style="gap: 8px">
            <mat-icon>calendar_today</mat-icon>
            <strong>Data Selecionada</strong>
          </span>
          <div class="d-flex align-items-center ms-3" style="gap: 12px">
            <mat-button-toggle-group
              [value]="selectedModalListType"
              (change)="onChangeModalListType($event.value)"
              appearance="legacy"
              data-cy="modal-list-type-toggle-group"
            >
              <mat-button-toggle value="ROTINAS" data-cy="modal-toggle-rotinas">
                <mat-icon inline>list_alt</mat-icon>
                <span class="ms-1">Rotinas</span>
                <span class="ms-1">({{ (activities$ | async)?.length || 0 }})</span>
              </mat-button-toggle>
              <mat-button-toggle value="TAREFAS" data-cy="modal-toggle-tarefas">
                <mat-icon inline>task</mat-icon>
                <span class="ms-1">Tarefas</span>
                <span class="ms-1">({{ tasksForModal?.length || 0 }})</span>
              </mat-button-toggle>
              <mat-button-toggle value="METAS" data-cy="modal-toggle-metas">
                <mat-icon inline>track_changes</mat-icon>
                <span class="ms-1">Metas</span>
                <span class="ms-1">({{ goalsForModal?.length || 0 }})</span>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </mat-toolbar>

        <!-- Toolbar Mobile para o Modal -->
        <div class="modal-mobile-list-selector">
          <div class="mobile-list-header">
            <mat-icon>calendar_today</mat-icon>
            <span>Data Selecionada</span>
          </div>
          <mat-button-toggle-group
            [value]="selectedModalListType"
            (change)="onChangeModalListType($event.value)"
            appearance="legacy"
            data-cy="modal-list-type-toggle-group-mobile"
          >
            <mat-button-toggle value="ROTINAS" data-cy="modal-toggle-rotinas-mobile">
              <mat-icon inline>list_alt</mat-icon>
              <span>Rotinas</span>
              <span>({{ (activities$ | async)?.length || 0 }})</span>
            </mat-button-toggle>
            <mat-button-toggle value="TAREFAS" data-cy="modal-toggle-tarefas-mobile">
              <mat-icon inline>task</mat-icon>
              <span>Tarefas</span>
              <span>({{ tasksForModal?.length || 0 }})</span>
            </mat-button-toggle>
            <mat-button-toggle value="METAS" data-cy="modal-toggle-metas-mobile">
              <mat-icon inline>track_changes</mat-icon>
              <span>Metas</span>
              <span>({{ goalsForModal?.length || 0 }})</span>
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div *ngIf="displayedModalItems?.length > 0">
          <h2 class="mb-4">Avaliações:</h2>

          <div>
            <ul class="list-group minimal-list">
              <li
                *ngFor="let activity of displayedModalItems; trackBy: trackByActivityId"
                class="list-group-item spacing-item"
              >
                <div class="w-100 d-flex justify-content-between align-items-center activity-row">
                  <span class="text-column text-wrap">{{ activity.name }}</span>
                  <div class="radio-group">
                    <div
                      *ngFor="let tag of tags; trackBy: trackByTagId"
                      [ngClass]="['radio-button_' + tag.class, tag.id === activity.tag?.id ? 'checked' : '']"
                      (click)="openAppointmentCreateModal(activity, tag)"
                      [class.checked]="tag.id === activity.tag?.id"
                      matTooltip="{{ tag.description }}"
                    ></div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="displayedModalItems?.length == 0" class="mt-4">
          <img src="../../../../../assets/img/empty-box.png" alt="empty" class="empty" />
          <h4>Nenhum item cadastrado para o cargo.</h4>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="person != null"
  class="modal fade"
  id="appointmentsCreateModal"
  tabindex="-1"
  aria-labelledby="appointmentsCreateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="max-width: fit-content">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h2>Avaliação:</h2>
        <p>Cadastre uma nova avaliação para {{ person.name }}.</p>

        <!-- Informações do funcionário, empresa, data e rotina selecionadas -->
        <div class="alert alert-info mb-3" role="alert">
          <div class="row">
            <div class="col-md-6"><strong>👤 Funcionário:</strong> {{ person?.name }}</div>
            <div class="col-md-6"><strong>🏢 Empresa:</strong> {{ person?.officeName }}</div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6"><strong>📅 Data Selecionada:</strong> {{ selectedDateForModal$ | async }}</div>
            <div class="col-md-6">
              <strong
                >🔄
                {{
                  selectedListType === "ROTINAS" ? "Rotina" : selectedListType === "TAREFAS" ? "Tarefa" : "Meta"
                }}:</strong
              >
              {{ selectedActivityName$ | async }}
            </div>
          </div>
        </div>

        <form [formGroup]="formAppointment" (ngSubmit)="onSubmitFormAppointment()">
          <div class="mb-3" hidden>
            <label for="id" class="form-label">ID</label>
            <input class="form-control" id="id" formControlName="id" />
          </div>

          <!-- Campos ocultos necessários para o patchValue -->
          <input type="hidden" formControlName="personId" />
          <input type="hidden" formControlName="activityId" />
          <input type="hidden" formControlName="tagId" />

          <div class="mb-3">
            <label for="description" class="form-label">Ocorrência *</label>
            <textarea
              class="form-control"
              id="description"
              rows="3"
              formControlName="description"
              placeholder="Digite a ocorrência aqui"
              data-cy="appointment-description-input"
            ></textarea>
            <div *ngIf="appointmentDescription?.errors?.maxlength">
              Máximo de letras excedido! Por favor, o limite de letras é de {{ maxLength }}.
            </div>
            <div>Letras restantes: {{ maxLength - (appointmentDescription?.value?.length || 0) }}</div>
          </div>

          <div class="mb-3">
            <label for="justification" class="form-label">Justificativa do colaborador</label>
            <textarea
              class="form-control"
              id="justification"
              rows="3"
              formControlName="justification"
              placeholder="Digite a justificativa do funcionário aqui"
            ></textarea>
            <div *ngIf="appointmentJustification?.errors?.maxlength">
              Máximo de letras excedido! Por favor, o limite de letras é de {{ maxLength }}.
            </div>
            <div>Letras restantes: {{ maxLength - (appointmentJustification?.value?.length || 0) }}</div>
          </div>

          <button
            *ngIf="!isSavingAppointment"
            [disabled]="!formAppointment.valid"
            type="submit"
            class="btn btn-primary w-100"
            data-cy="save-appointment-button"
          >
            Salvar
          </button>
        </form>
        <div *ngIf="isSavingAppointment" class="spinner-container">
          <div class="spinner"></div>
        </div>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="closeAppointmentCreateModal()">Fechar</button>
      </div> -->
    </div>
  </div>
</div>

<!-- Modal de Atestados Médicos (Componente Separado) -->
<app-abstinence-modal
  [personName]="person?.name"
  [abstinences]="abstinences"
  [isSaving]="isSavingAbstinence"
  [maxLength]="maxLength"
  (editAbstinence)="onEditAbstinence($event)"
  (deleteAbstinence)="onDeleteAbstinence($event)"
  (createAbstinence)="openAbstinenceCreateModal()"
  (submitForm)="onSubmitFormAbstinence($event)"
  (fileSelected)="onAbstinenceFileSelected($event)"
>
</app-abstinence-modal>

<!-- Modal de Férias (Componente Separado) -->
<app-vacation-modal
  [personName]="person?.name"
  [vacations]="vacationsForModal"
  [isSaving]="isSavingVacation"
  [maxLength]="maxLength"
  (editVacation)="onEditVacation($event)"
  (deleteVacation)="onDeleteVacationV2($event)"
  (createVacation)="openVacationCreateModal()"
  (submitForm)="onSubmitFormVacation($event)"
>
</app-vacation-modal>

<!-- Modal de Relatórios -->
<div class="modal fade" id="reportsModal" tabindex="-1" aria-labelledby="reportsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="reportsModalLabel">Relatório de Avaliação</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="container my-3">
          <!-- Informações do funcionário -->
          <div class="alert alert-info mb-3" role="alert">
            <div class="row">
              <div class="col-md-12"><strong>👤 Funcionário:</strong> {{ person?.name }}</div>
            </div>
          </div>

          <form [formGroup]="formReport" (ngSubmit)="onSubmitReportForm()">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="reportStartDate" class="form-label">Data de Início *</label>
                <input
                  type="date"
                  class="form-control"
                  id="reportStartDate"
                  formControlName="startDate"
                  [ngClass]="{
                    'is-invalid': formReport.get('startDate')?.invalid && formReport.get('startDate')?.touched,
                    'is-valid': formReport.get('startDate')?.valid && formReport.get('startDate')?.touched
                  }"
                />
                <div
                  *ngIf="formReport.get('startDate')?.invalid && formReport.get('startDate')?.touched"
                  class="invalid-feedback"
                >
                  A data de início é obrigatória.
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label for="reportEndDate" class="form-label">Data de Fim *</label>
                <input
                  type="date"
                  class="form-control"
                  id="reportEndDate"
                  formControlName="endDate"
                  [ngClass]="{
                    'is-invalid': formReport.get('endDate')?.invalid && formReport.get('endDate')?.touched,
                    'is-valid': formReport.get('endDate')?.valid && formReport.get('endDate')?.touched
                  }"
                />
                <div
                  *ngIf="formReport.get('endDate')?.invalid && formReport.get('endDate')?.touched"
                  class="invalid-feedback"
                >
                  A data de fim é obrigatória.
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <button
                  *ngIf="!isLoadingReport"
                  type="submit"
                  class="btn btn-primary w-100"
                  [disabled]="formReport.invalid"
                >
                  <i class="fas fa-file-pdf me-2"></i>
                  Gerar Relatório PDF
                </button>
                <div *ngIf="isLoadingReport" class="spinner-container">
                  <div class="spinner"></div>
                  <p class="text-center mt-3">Gerando relatório...</p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modais de feedback do relatório -->
<div
  class="modal fade"
  id="reportNoContentModal"
  tabindex="-1"
  aria-labelledby="reportNoContentModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-warning text-dark">
        <h5 class="modal-title" id="reportNoContentModalLabel">
          <i class="fas fa-exclamation-triangle me-2"></i>
          Nenhuma Avaliação Encontrada
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center py-4">
        <div class="mb-4">
          <i class="fas fa-inbox fa-4x text-muted"></i>
        </div>
        <h5 class="mb-3">Não há avaliações para o período selecionado</h5>
        <div class="alert alert-info text-start" role="alert">
          <div class="mb-2">
            <strong><i class="fas fa-user me-2"></i>Funcionário:</strong> {{ person?.name }}
          </div>
          <div class="mb-2">
            <strong><i class="fas fa-calendar-alt me-2"></i>Período Selecionado:</strong>
            <span *ngIf="reportPeriod.startDate && reportPeriod.endDate">
              De {{ reportPeriod.startDate }} até {{ reportPeriod.endDate }}
            </span>
            <span *ngIf="!reportPeriod.startDate || !reportPeriod.endDate" class="text-muted">
              Período não selecionado
            </span>
          </div>
        </div>
        <p class="text-muted mb-0">
          <i class="fas fa-info-circle me-2"></i>
          Tente selecionar um período diferente ou verifique se existem avaliações cadastradas para este funcionário.
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          <i class="fas fa-times me-2"></i>
          Fechar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="reportSuccessModal" tabindex="-1" aria-labelledby="reportSuccessModal" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <img src="../../../../../assets/img/success-icon.svg" width="100" height="100" alt="" />
        <p class="mt-4">PDF Gerado com sucesso.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>

<app-spinner *ngIf="!isInitialDataReady"></app-spinner>

<!-- Conteúdo principal -->
<div *ngIf="isInitialDataReady" class="container-fluid mt-4 mb-4 appointment-container">
  <!-- Título da página -->
  <div class="page-header mb-4">
    <h1 class="page-title">Tabela de Avaliações</h1>
    <p class="page-subtitle" *ngIf="person?.name">{{ getPersonTypeLabel() }}: {{ person.name }}</p>
  </div>

  <!-- Seletor de Lista: Rotinas / Tarefas / Metas -->
  <mat-toolbar color="primary" class="mb-3 list-selector-toolbar toolbar-desktop" style="border-radius: 8px">
    <span class="toolbar-title d-flex align-items-center" style="gap: 8px">
      <mat-icon>dashboard</mat-icon>
    </span>
    <div class="toolbar-actions d-flex align-items-center ms-3" style="gap: 12px">
      <mat-button-toggle-group
        [value]="selectedListType"
        (change)="onChangeListType($event.value)"
        appearance="legacy"
        data-cy="list-type-toggle-group"
      >
        <mat-button-toggle value="ROTINAS" data-cy="toggle-rotinas">
          <mat-icon inline>list_alt</mat-icon>
          <span class="ms-1">Rotinas</span>
          <span class="ms-1" *ngIf="activitiesDailyResponse">({{ activitiesDailyResponse?.length || 0 }})</span>
        </mat-button-toggle>
        <mat-button-toggle value="TAREFAS" data-cy="toggle-tarefas">
          <mat-icon inline>task</mat-icon>
          <span class="ms-1">Tarefas</span>
          <span class="ms-1" *ngIf="tasksForList">({{ tasksForList?.length || 0 }})</span>
        </mat-button-toggle>
        <mat-button-toggle value="METAS" data-cy="toggle-metas">
          <mat-icon inline>track_changes</mat-icon>
          <span class="ms-1">Metas</span>
          <span class="ms-1" *ngIf="goalsForList">({{ goalsForList?.length || 0 }})</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </mat-toolbar>

  <!-- Toolbar Mobile -->
  <div class="mobile-list-selector">
    <div class="mobile-list-header">
      <mat-icon>dashboard</mat-icon>
      <span>Selecione a visão</span>
    </div>
    <mat-button-toggle-group
      [value]="selectedListType"
      (change)="onChangeListType($event.value)"
      appearance="legacy"
      data-cy="list-type-toggle-group-mobile"
    >
      <mat-button-toggle value="ROTINAS" data-cy="toggle-rotinas-mobile">
        <mat-icon inline>list_alt</mat-icon>
        <span>Rotinas</span>
        <span *ngIf="activitiesDailyResponse">({{ activitiesDailyResponse?.length || 0 }})</span>
      </mat-button-toggle>
      <mat-button-toggle value="TAREFAS" data-cy="toggle-tarefas-mobile">
        <mat-icon inline>task</mat-icon>
        <span>Tarefas</span>
        <span *ngIf="tasksForList">({{ tasksForList?.length || 0 }})</span>
      </mat-button-toggle>
      <mat-button-toggle value="METAS" data-cy="toggle-metas-mobile">
        <mat-icon inline>track_changes</mat-icon>
        <span>Metas</span>
        <span *ngIf="goalsForList">({{ goalsForList?.length || 0 }})</span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Nova Grid com 2 elementos (2/3 e 1/3) -->
  <div class="main-grid-container">
    <!-- Primeiro elemento - 2/3 do espaço -->
    <div class="grid-item-large">
      <div class="card">
        <div class="card-body">
          <mat-tab-group
            [selectedIndex]="selectedTab.value"
            (selectedIndexChange)="selectedTab.setValue($event)"
            data-cy="appointment-tabs"
          >
            <mat-tab data-cy="tab-diaria">
              <ng-template mat-tab-label>
                <mat-icon *ngIf="selectedTab.value == 0" class="example-tab-icon">arrow_right</mat-icon>
                Diária
              </ng-template>

              <section class="monthly-container mat-elevation-z2" tabindex="0">
                <mat-list>
                  <!-- Rotina de demonstração - sempre visível -->
                  <mat-list-item>
                    <div class="list-item-row w-100 d-flex justify-content-between align-items-center">
                      <span class="text-column text-center text-wrap"><strong>🎨 Demonstração de Cores</strong></span>
                      <div class="radio-group">
                        <div
                          *ngFor="let option of options"
                          [ngClass]="['radio-button_' + option.color, 'checked']"
                          matTooltip="{{ option.description }}"
                        ></div>
                      </div>
                    </div>
                  </mat-list-item>
                  <mat-divider></mat-divider>

                  <!-- Itens conforme seleção (Rotinas/Tarefas/Metas) -->
                  <ng-container
                    *ngIf="displayedDailyItems != null && displayedDailyItems.length > 0; else noItemsState"
                  >
                    <ng-container *ngFor="let activity of displayedDailyItems">
                      <mat-list-item class="activity-list-item">
                        <div class="w-100 d-flex justify-content-between align-items-center activity-row">
                          <span class="text-column text-wrap">{{ activity.name }}</span>
                          <div class="radio-group" [attr.data-cy]="'activity-tags-' + activity.id">
                            <div
                              *ngFor="let tag of tags; let tagIndex = index"
                              [ngClass]="['radio-button_' + tag.class, tag.id === activity.tag?.id ? 'checked' : '']"
                              (click)="openAppointmentCreateModal(activity, tag)"
                              [class.checked]="tag.id === activity.tag?.id"
                              matTooltip="{{ tag.description }}"
                              [attr.data-cy]="'tag-button-' + tag.id"
                            ></div>
                          </div>
                        </div>
                      </mat-list-item>
                      <mat-divider></mat-divider>
                    </ng-container>
                  </ng-container>

                  <!-- Estado vazio - Loading ou sem itens -->
                  <ng-template #loadingState>
                    <div class="empty-state loading-state">
                      <div class="spinner-container">
                        <div class="spinner"></div>
                      </div>
                      <h4>Carregando itens...</h4>
                      <p>Por favor, aguarde enquanto buscamos os dados.</p>
                    </div>
                  </ng-template>

                  <ng-template #noItemsState>
                    <div *ngIf="displayedDailyItems == null; else emptyState" class="mt-3">
                      <ng-container *ngTemplateOutlet="loadingState"></ng-container>
                    </div>
                    <ng-template #emptyState>
                      <div class="empty-state no-data-state">
                        <div class="empty-icon">
                          <i class="fas fa-clipboard-list"></i>
                        </div>
                        <h4>Nenhum item encontrado</h4>
                        <p>Não há dados para exibir no momento.</p>
                      </div>
                    </ng-template>
                  </ng-template>
                </mat-list>
              </section>
            </mat-tab>

            <mat-tab data-cy="tab-mensal">
              <ng-template mat-tab-label>
                <mat-icon *ngIf="selectedTab.value == 1">arrow_right</mat-icon> Mensal
              </ng-template>
              <div class="grid-container">
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassCurrentMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDay"
                    [maxDate]="lastDay"
                    data-cy="calendar-mensal"
                  ></mat-calendar>
                </div>
              </div>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon *ngIf="selectedTab.value == 2">arrow_right</mat-icon> Trimestral
              </ng-template>
              <div class="grid-container">
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassLastTwoMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDayLastTwoMonth"
                    [maxDate]="lastDayLastTwoMonth"
                  ></mat-calendar>
                </div>
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassLastMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDayLastMonth"
                    [maxDate]="lastDayLastMonth"
                  ></mat-calendar>
                </div>
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassCurrentMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDay"
                    [maxDate]="lastDay"
                  ></mat-calendar>
                </div>
              </div>
            </mat-tab>

            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon *ngIf="selectedTab.value == 3" class="example-tab-icon">arrow_right</mat-icon>
                Semestral
              </ng-template>
              <div class="grid-container">
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassLastFiveMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDayLastFiveMonth"
                    [maxDate]="lastDayLastFiveMonth"
                  ></mat-calendar>
                </div>
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassLastFourMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDayLastFourMonth"
                    [maxDate]="lastDayLastFourMonth"
                  ></mat-calendar>
                </div>
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassLastThreeMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDayLastThreeMonth"
                    [maxDate]="lastDayLastThreeMonth"
                  ></mat-calendar>
                </div>
              </div>
              <div class="grid-container">
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassLastTwoMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDayLastTwoMonth"
                    [maxDate]="lastDayLastTwoMonth"
                  ></mat-calendar>
                </div>
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassLastMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDayLastMonth"
                    [maxDate]="lastDayLastMonth"
                  ></mat-calendar>
                </div>
                <div>
                  <mat-calendar
                    [(selected)]="selected"
                    [dateClass]="dateClassCurrentMonth"
                    (click)="openAppointmentModal()"
                    [minDate]="firstDay"
                    [maxDate]="lastDay"
                  ></mat-calendar>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>

    <!-- Segundo elemento - 1/3 do espaço -->
    <div class="grid-item-small">
      <div class="card employee-profile-card">
        <div class="card-body">
          <!-- Header do Funcionário -->
          <div class="employee-header">
            <div class="employee-avatar">
              <app-avatar
                [src]="getEmployeePhoto()"
                alt="Foto do funcionário"
                size="medium"
                [showStatus]="true"
                status="active"
              ></app-avatar>
            </div>
            <div class="employee-info">
              <h4 class="employee-name">{{ person?.name || "Nome não informado" }}</h4>
              <span class="employee-status-badge active"> Ativo </span>
            </div>
          </div>

          <!-- Informações da Empresa -->
          <div class="company-info">
            <div class="info-item">
              <i class="fas fa-building"></i>
              <span>{{ person?.officeName || "Empresa não informada" }}</span>
            </div>
            <div class="info-item">
              <i class="fas fa-id-card"></i>
              <span>{{ person?.contractType || "Tipo não informado" }}</span>
            </div>
          </div>

          <!-- Ações Rápidas -->
          <div class="quick-actions">
            <h5>Ações Rápidas</h5>
            <div class="action-buttons">
              <button
                class="btn btn-outline-primary btn-sm action-btn"
                (click)="openAbstinencesModal()"
                data-cy="open-abstinences-modal"
              >
                <i class="fas fa-file-medical"></i>
                <span>Atestados</span>
              </button>
              <button
                class="btn btn-outline-success btn-sm action-btn"
                (click)="openVacationsModal()"
                data-cy="open-vacations-modal"
              >
                <i class="fas fa-calendar-check"></i>
                <span>Férias</span>
              </button>
              <button
                class="btn btn-outline-info btn-sm action-btn"
                (click)="openReportsModal()"
                data-cy="open-reports-modal"
              >
                <i class="fas fa-file-alt"></i>
                <span>Relatórios</span>
              </button>
            </div>
          </div>

          <!-- Estatísticas Rápidas -->
          <div class="quick-stats">
            <h5>Estatísticas</h5>
            <div class="stats-grid">
              <div class="stat-item">
                <div class="stat-value">{{ totalEvaluationsLast6Months }}</div>
                <div class="stat-label">Avaliações</div>
              </div>
              <div class="stat-item">
                <div class="stat-value">{{ evaluationsThisMonth }}</div>
                <div class="stat-label">Este Mês</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
